import type { ObjectMetadata } from '@olytic/foundation';

import { formatMonthYear, formatNumber } from '../../objects/format';
import { OBJECT_DEFS } from '../../objects/objectDefs';
import { asDateTime, asLabel, column, createdByField, field, lastModifiedByField, type Row, related, show, text } from './kit';

const def = OBJECT_DEFS.people;
const hours = show((v) => `${formatNumber(v)}h`);
const month = show(formatMonthYear);

/** A person: their usual monthly hours and the roles they fill. Rationale: people.md. */
export const people: ObjectMetadata<Row> = {
  key: def.key,
  singular: 'Person',
  plural: def.label,
  icon: def.icon,
  listColumns: def.columns,
  details: [
    field('name', 'Name'),
    field('email', 'Email'),
    field('monthly_capacity_hours', 'Usual Monthly Hours', { format: hours }),
    field('primary_role_name', 'Primary Role'),
    field('created_at', 'Created', { format: asDateTime }),
    createdByField(),
    lastModifiedByField(),
  ],
  sections: [
    { key: 'identity', fields: ['name', 'email', 'monthly_capacity_hours', 'primary_role_name'] },
    { key: 'system', label: 'System', collapsed: true, fields: ['created_at', 'created_by_name', 'last_modified_by_name'] },
  ],
  related: [
    related('roles', 'Roles', 'user-resource-roles', [
      column('name', 'Role', { primary: true }),
      column('is_primary', 'Primary'),
    ]),
    related('capacity', 'Capacity Months', 'resource-capacity', [
      column('name', 'Month', { primary: true }),
      column('hours', 'Hours', { format: hours, align: 'right' }),
      column('note', 'Note'),
    ]),
    related('resource-assignments', 'Resource Assignments', 'resource-assignments', [
      column('name', 'Assignment', { primary: true }),
      column('month', 'Month', { format: month }),
      column('hours', 'Hours', { format: hours, align: 'right' }),
      column('status', 'Status', { format: asLabel }),
    ]),
  ],
  titleOf: (row) => text(row.name),
  searchKeys: ['name', 'email'],
};
